module.exports = __webpack_public_path__ + "static/img/7.226a099.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/eng/7.png
// module id = Ma92
// module chunks = 0